let routeUpdateAudioElement;

exports.onClientEntry = () => {
	routeUpdateAudioElement = new Audio("/sounds/click.mp3");
	window.addEventListener("click", () => {
		if (window.__navigatingToLink) routeUpdateAudioElement.play();
	});
};
